var render, staticRenderFns
import script from "./AxTreeNode.vue?vue&type=script&lang=ts&"
export * from "./AxTreeNode.vue?vue&type=script&lang=ts&"
import style0 from "./AxTreeNode.vue?vue&type=style&index=0&id=3c4b2a82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4b2a82",
  null
  
)

export default component.exports